import axiosInstance from 'api/axiosInstance';

export const updateCheckpoints = async (
	updatedCheckpoints: PatrolCheckpoint[],
): Promise<void> => {
	let url = '/Project/WebService/CANDispatch.asmx/SubmitChecklistV3';
	if (process.env.NODE_ENV === 'production') {
		url = '/Portal' + url;
	}
	// Map the updated checkpoints to the format the API expects
	const payload = updatedCheckpoints.map((checkpoint) => {
		return {
			CheckpointID: checkpoint.CheckpointID,
			Time: checkpoint.Time,
			Comment: checkpoint.Comment,
			SelectedStatusID: checkpoint.SelectedStatusID,
			SelectedDropdownIDs: checkpoint.SelectedDropdownIDs,
			DateTime: checkpoint.DateTime,
		};
	});
	const response = await axiosInstance.post(url, {
		payload: JSON.stringify(payload),
	});
	if (response.status !== 200) {
		throw new Error('Error updating checkpoints');
	}
};
